import "@/App.css";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { SoundProvider } from "@/sound/SoundContext";
import Landing from "@/pages/Landing";
import IntroGate from "@/components/pusheen/IntroGate";

function Shell() {
  const [entered, setEntered] = useState(false);
  return (
    <>
      <Landing />
      <AnimatePresence>
        {!entered && <IntroGate onEnter={() => setEntered(true)} />}
      </AnimatePresence>
    </>
  );
}

function App() {
  return (
    <SoundProvider>
      <Shell />
      <Toaster position="top-center" />
    </SoundProvider>
  );
}

export default App;
